import React from 'react';
import Notifications from './exact';

import { Roles } from '../../../../routing/child-router-factory';

import {
  CreateConfigFn,
  nonAuthenticatedRedirect,
  pathJoin,
} from '../../../../routing/utils';

import NotificationFlow from './NotificationFlow';

export type Keys = `sms` | `email` | 'exact';

export const createRoutesMap = (prefix: string) => ({
  sms: pathJoin(prefix)('sms').chain,
  email: pathJoin(prefix)('email').chain,
});

const authenticatedUser: Roles = {
  and: ['authenticated'],
};

// create-config function.
export const createConfig: CreateConfigFn<Keys> = (map) => [
  {
    key: 'sms',
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
    roles: authenticatedUser,

    children: <NotificationFlow mode="sms" />,
    path: map.app.notifications.sms._,
  },
  {
    key: 'email',
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
    roles: authenticatedUser,

    children: <NotificationFlow mode="email" />,
    path: map.app.notifications.email._,
  },
  {
    key: 'exact',
    fallback: (roles) => nonAuthenticatedRedirect(map)(roles),
    roles: authenticatedUser,

    children: <Notifications />,
    path: map.app.notifications._,
    exact: true,
  },
];
